/**
 * Highlights matching text within a string
 * @param text The text to search within
 * @param query The search query
 * @returns HTML string with highlighted matches
 */
export function highlightText(text: string, query: string): string {
  if (!query || !text) {
    return text;
  }

  const normalizedQuery = query.toLowerCase().trim();
  const normalizedText = text.toLowerCase();
  
  if (!normalizedQuery) {
    return text;
  }

  const index = normalizedText.indexOf(normalizedQuery);
  
  if (index === -1) {
    return text;
  }

  const before = text.substring(0, index);
  const match = text.substring(index, index + query.length);
  const after = text.substring(index + query.length);

  return `${before}<span class="search-highlight">${match}</span>${after}`;
}

/**
 * Highlights multiple occurrences of text
 * @param text The text to search within
 * @param query The search query
 * @returns HTML string with all matches highlighted
 */
export function highlightAllText(text: string, query: string): string {
  if (!query || !text) {
    return text;
  }

  const normalizedQuery = query.toLowerCase().trim();
  
  if (!normalizedQuery) {
    return text;
  }

  // Use regex to replace all occurrences
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  
  return text.replace(regex, '<span class="search-highlight">$1</span>');
}
